import { SharedService } from './../@admin/services/shared/shared.service';
import {Component, ElementRef, OnDestroy, OnInit} from '@angular/core';
import {animate, style, transition, trigger} from '@angular/animations';
import {LayoutService} from './service/app.layout.service';
import {NgClass, NgIf} from "@angular/common";
import {RouterLink} from "@angular/router";
import {TooltipModule} from "primeng/tooltip";
import {AuthService} from "../core/auth/auth.service";
import {AppraiserUtilsService} from "../@admin/services/utils";
import {AzureProfileResponse} from "../api/models/response/azure-profile-response";
import {DialogService, DynamicDialogRef} from "primeng/dynamicdialog";
import { ProfileDetails } from '../api/models';
import { AdminRoles } from '../@admin/utils/constant/common.const';

@Component({
  selector: 'app-menu-profile',
  templateUrl: './app.menuprofile.component.html',
  animations: [
    trigger('menu', [
      transition('void => inline', [
        style({height: 0}),
        animate(
          '400ms cubic-bezier(0.86, 0, 0.07, 1)',
          style({opacity: 1, height: '*'})
        ),
      ]),
      transition('inline => void', [
        animate(
          '400ms cubic-bezier(0.86, 0, 0.07, 1)',
          style({opacity: 0, height: '0'})
        ),
      ]),
      transition('void => overlay', [
        style({opacity: 0, transform: 'scaleY(0.8)'}),
        animate('.12s cubic-bezier(0, 0, 0.2, 1)'),
      ]),
      transition('overlay => void', [
        animate('.1s linear', style({opacity: 0})),
      ]),
    ]),
  ],
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    RouterLink,
    TooltipModule
  ]
})
export class AppMenuProfileComponent implements OnInit , OnDestroy{

  profile: AzureProfileResponse = {};
  profileDetails: ProfileDetails = {};
  AdminRoles = AdminRoles;

  ref!: DynamicDialogRef;

  constructor(public layoutService: LayoutService,
              public el: ElementRef,
              public _authService: AuthService,
              public _utilityService: AppraiserUtilsService,
    public dialogService: DialogService, private _shared: SharedService) {
  }


  ngOnInit() {
    this._utilityService.profileDetails$.pipe().subscribe({
      next: (res) => {
        this.profileDetails = res;
      }
    })
    this._utilityService.profileInfo$.subscribe({
      next: (res) => {
        this.profile = res;
      }
    })
  }

  toggleMenu() {
    this.layoutService.onMenuProfileToggle();
  }

  get isHorizontal() {
    return (
      this.layoutService.isHorizontal() && this.layoutService.isDesktop()
    );
  }

  get menuProfileActive(): boolean {
    return this.layoutService.state.menuProfileActive;
  }

  get menuProfilePosition(): string {
    return this.layoutService.config().menuProfilePosition;
  }

  get isTooltipDisabled(): boolean {
    return !this.layoutService.isSlim();
  }
  showProfileDialog() {
    this._shared.showProfileDetialsDiag();
    // this.ref = this.dialogService.open(ProfileComponent, {
    //   header: 'Profile Details',
    //   width: '30vw',
    //   modal: true,
    //   breakpoints: {
    //     '1340px': '50vw',
    //     '960px': '75vw',
    //     '640px': '90vw'
    //   },
    //   contentStyle: { 'max-height': '500px', overflow: 'auto' },
    //   baseZIndex: 10000,
    // });
  }
  redirectUserPage(){
    window.location.href = '/users';
  }
  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }

  getFirstLetter(name: string): string {
    return name ? name.charAt(0).toUpperCase() : '';
  }
}
